import React, { ReactNode } from "react";
import { BalanceProvider } from "../provider/Balance";
// import { AuthProvider } from "./AuthContext";
// import { ThemeProvider } from "./ThemeContext";



type ProviderItem = {
  Component: React.ComponentType<{ children: ReactNode }>;
  priority?: number;
};

const providers: ProviderItem[] = [
  {
    Component: BalanceProvider,
    priority: 1,
  },
  // { Component: AuthProvider, priority: 2 },
  // { Component: ThemeProvider, priority: 4 },
];

export const ContextComposer: React.FC<{ children: ReactNode }> = ({ children }) => {
  const sorted = [...providers].sort(
    (a, b) => (a.priority ?? 0) - (b.priority ?? 0)
  );

  return (
    <>
      {sorted.reduceRight((acc, { Component }) => {
        return <Component>{acc}</Component>;
      }, children)}
    </>
  );
};
